<template>
  <md-list>
    <md-list-item :to="{ name: 'Home' }" @click="hide()">
      {{ $t("home") }}
    </md-list-item>

    <!-- <md-list-item to="/about" @click="menuVisible = false">About</md-list-item> -->
  </md-list>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "LayoutLinks",
  computed: {
    ...mapGetters({
      authorities: "getAuthoritiesSections",
    }),
  },
  methods: {
    hide() {
      this.$emit("clicked");
    },
  },
};
</script>